export default __webpack_public_path__ + "static/media/shf.bb6da525.svg";